import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Super user management", -1)
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      class: "pt-2 mx-4",
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                              width: "500",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetDialog()))
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "200",
                                  variant: "tonal",
                                  color: "primary"
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-account-plus",
                                      start: ""
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Add super user' : 'Add'), 1)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_card, { title: "Add a super user" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_form, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  md: "6"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      "hide-details": "",
                                                      density: "compact",
                                                      label: "First name",
                                                      modelValue: _ctx.user.first_name,
                                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.first_name) = $event))
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  md: "6"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      "hide-details": "",
                                                      density: "compact",
                                                      label: "Last name",
                                                      modelValue: _ctx.user.last_name,
                                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.last_name) = $event))
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      "hide-details": "",
                                                      density: "compact",
                                                      label: "Email",
                                                      modelValue: _ctx.user.email,
                                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event)),
                                                      type: "email"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          loading: _ctx.loading,
                                          disabled: !_ctx.user.first_name || !_ctx.user.last_name || !_ctx.user.email || _ctx.loading,
                                          color: "primary",
                                          onClick: ($event: any) => {_ctx.addSuperUser(); isActive.value = false}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Add super user ")
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "disabled", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              size: "small",
                              width: "200",
                              variant: "tonal",
                              disabled: !_ctx.selectedUsers.length,
                              color: "primary",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeSuperUser()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-account-minus",
                                  start: ""
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Remove super user' : 'Remove'), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      "hide-details": "",
                      density: "compact",
                      placeholder: "Search super users",
                      "append-inner-icon": "mdi-magnify",
                      modelValue: _ctx.searchNames,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchNames) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      items: _ctx.users,
      headers: _ctx.headers,
      "show-select": "",
      "return-object": "",
      modelValue: _ctx.selectedUsers,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedUsers) = $event)),
      height: "calc(100vh - 180px)",
      "onUpdate:sortBy": _ctx.updateTableOptions,
      "items-per-page": "25"
    }, {
      [`item.avatar`]: _withCtx(({ item }) => [
        _createVNode(_component_v_avatar, { color: "secondary" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.initials(item.first_name, item.last_name)), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.full_name`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.fullName(item.first_name, item.last_name)), 1)
      ]),
      [`item.status`]: _withCtx(({ item }) => [
        (item.status === 'active')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "success"
              }),
              _createTextVNode(" Active ")
            ]))
          : _createCommentVNode("", true),
        (item.status === 'pending')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "grey"
              }),
              _createTextVNode(" Pending ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, 1032, ["items", "headers", "modelValue", "onUpdate:sortBy"])
  ]))
}